import axios from "axios";

const elasticInstace = axios.create({
  baseURL: `https://es-product-search.devops.multpex.com.br`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json;",
    "x-api-key": "weijefioejv03iehjvwiov0w3ijv",
  },
});

const actions = {
  //Listar Produtos

  listarProdutos: async (
    context,
    { per_page, page, search, contract_id, ca_status, ca_code, status }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.get(`contracts/${contract_id}/products`, {
      params: {
        per_page,
        page,
        search,
        status,
        ca_status,
        ca_code,
      },
    });

    return response;
  },

  uploadImagem: async (context, { product_id, image, contract_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.post(`products/upload-image-v2`, {
      product_id,
      image,
      contract_id,
    });

    return response;
  },

  deletarImagem: async (context, { productId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.delete(`products/upload-image/${productId}`);

    return response;
  },

  alterarMultiplo: async (context, { productId, vendorId, multiplo }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.put(
      `products/${productId}/vendor/${vendorId}/multiplo/${multiplo}`
    );

    return response;
  },

  // Categorias

  listarCategorias: async (context, { per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.get(`product-categories`, {
      params: {
        per_page,
        page,
      },
    });

    return response;
  },

  adicionarCategoria: async (context, { code, description }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.post(`product-categories`, {
      code,
      description,
    });

    return response;
  },

  // Gestão de EPI's

  adicionarCa: async (context, { code, expires_in, format }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.post(`cas`, {
      code,
      expires_in,
      format,
    });

    return response;
  },

  associarCa: async (context, { catalog_id, products }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.put(`contracts/${catalog_id}/products`, {
      products,
    });

    return response;
  },

  listarCas: async (context, { per_page, code, page, status }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cas`, {
      params: {
        per_page,
        code,
        page,
        status,
      },
    });
    return response;
  },

  atualizarCa: async (context, { code, expires_in, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`cas/${id}`, {
      expires_in,
      id,
      code,
    });
    return response;
  },

  removerCategoria: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`product-categories/${id}`);
    return response;
  },

  getUnidades: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/users?per_page=50`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  listarProdutosAcciona: async (context, { descricao = "teste" }) => {
    const response = elasticInstace.get("/search", {
      params: {
        descricao,
      },
    });

    return response;
  },
};

export const produtos = {
  namespaced: true,
  actions,
};
